import { useCallback } from "react";

import { Tooltip, Badge, IconButton } from "@material-ui/core";
import { columnTextField } from "utils/tables-utils";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";

import { makeStyles } from "@material-ui/core/styles";

import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddLinkIcon from "@mui/icons-material/AddLink";

const useCustomStyles = makeStyles((theme) => ({
  badge: ({ status }) => ({
    backgroundColor: status
      ? theme.palette.success.main
      : theme.palette.warning.light,
    height: 20,
    width: 20,
    borderRadius: 10,
    border: "none",
  }),
  root: {
    margin: "0 0.5rem",
  },
}));

const ColoredStatus = ({ status }) => {
  const classes = useCustomStyles({ status });

  return (
    <Tooltip title={status ? "Ativa" : "Inativa"}>
      <Badge
        overlap="circle"
        badgeContent=" "
        color="primary"
        classes={{ badge: classes.badge, root: classes.root }}
      />
    </Tooltip>
  );
};

export default function TableVitrineVirtual({
  dataTable,
  pagination,
  isLoading,
  onPageChange,
  onActionClick,
}) {
  const columnModel = [
    {
      dataField: "Ativo",
      text: "Status",
      align: "center",
      isDummyField: true,
      csvExport: false,
      headerAlign: "center",
      formatter: (cell, row) => {
        return <ColoredStatus status={row?.Ativo} />;
      },
    },
    columnTextField({
      dataField: "Nome",
      text: "Nome",
      align: "center",
    }),
    columnTextField({
      dataField: "Loja",
      text: "Loja",
      align: "center",
    }),
    columnTextField({
      dataField: "NomeUsuario",
      text: "Usuário",
      align: "center",
    }),
    columnTextField({
      dataField: "VitrinePublica",
      text: "Tipo",
      align: "center",
      formatter: (params) => (params ? "Compartilhada" : "Exclusiva"),
    }),
    columnTextField({
      dataField: "DataVigenciaInicioFormat",
      text: "Data Vigência - Início",
      align: "center",
    }),
    columnTextField({
      dataField: "DataVigenciaFimFormat",
      text: "Data Vigência - Fim",
      align: "center",
    }),
    {
      dataField: "editar",
      text: "",
      isDummyField: true,
      headerStyle: { width: 30 },
      formatter: (_, row) => {
        return (
          <Tooltip title="Editar Vitrine">
            <IconButton
              size="small"
              aria-label="edit"
              onClick={() => onActionClick("edit", row)}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      dataField: "visualizar",
      text: "Ações",
      isDummyField: true,
      headerStyle: { width: 30 },
      formatter: (cell, row) => (
        <Tooltip title="Detalhes da Vitrine">
          <IconButton
            size="small"
            aria-label="details"
            onClick={() => onActionClick("detail", row)}
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      dataField: "enviar",
      text: "",
      isDummyField: true,
      headerStyle: { width: 30 },
      formatter: (cell, row) => (
        <>
          {row.Ativo && (
            <Tooltip title="Criar link para a vitrine">
              <IconButton
                size="small"
                aria-label="send"
                onClick={() => onActionClick("send", row)}
              >
                <AddLinkIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      onPageChange(page, sizePerPage);
    },
    [onPageChange]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      onPageChange(page, sizePerPage);
    },
    [onPageChange]
  );

  return (
    <>
      <ToolkitTable
        searched={Boolean(dataTable)}
        keyField="IdVitrineVirtual"
        dataTable={dataTable}
        columnModel={columnModel}
        headerTitle="Suas Vitrines Virtuais"
        pagination={{
          options: [25, 50, 100],
          defaultOption: pagination.pageSize,
          totalSize: pagination.totalRegisters,
          showTotal: true,
          page: pagination.currentPage,
          sizePerPage: pagination.pageSize,
          onPageChange: handlePageChange,
          onSizePerPageChange: handleSizePerPageChange,
        }}
        loading={isLoading}
        notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
        bootstrapTableProps={{
          remote: true,
        }}
      />
    </>
  );
}
